
import {FC} from "react";
import {usePlan} from "../../context";
import {SummaryCard} from "../common";
import {OrganizationDetailsColumn} from "./OrganizationDetailsColumn";
import "../common/BuilderStep.scss";

export const ReviewPlanStep: FC = () => {
  const {plan} = usePlan();

  return (
    <section
      id={"review-plan-step"}
      data-testid={"review-plan-step"}
      className={"organization-builder-step review-plan-step"}>
      <section
        id={"summary-section"}
        data-testid={"summary-section"}
        className={"summary-section"}>
        <SummaryCard
          baseLabelKey={"create-organization.plan-summary"}
          qualifier={"creating"}
          count={1}
        />
        <SummaryCard
          baseLabelKey={"create-organization.plan-summary"}
          qualifier={plan.newEntity.tenantId ? "existing-tenant" : "new-tenant"}
          count={1}
          name={plan.source.hierarchy?.custName ?? ""}
        />
      </section>
      <section
        id={"organization-section"}
        data-testid={"organization-section"}
        className={"organization-section"}>
        <OrganizationDetailsColumn plan={plan} />
      </section>
    </section>
  );
};
